import { useState } from "react";
import { useAuth } from "./AuthContext.jsx";

export default function LoginScreen() {
  const { login, error } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(username, password);
    setBusy(false);
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--cream)",
    }}>
      <form onSubmit={submit} style={{
        background: "#fff", padding: "40px 36px", borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-card)", width: "340px", display: "flex", flexDirection: "column", gap: "16px",
      }}>
        <h1 style={{ fontSize: "22px", marginBottom: "4px" }}>Darlux Dashboard</h1>
        <p style={{ margin: 0, color: "var(--text-3)", fontSize: "14px" }}>Bitte einloggen</p>
        <input
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={inputStyle}
          autoFocus
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        {error ? <div style={{ color: "var(--status-abgesagt-fg)", fontSize: "13px" }}>{error}</div> : null}
        <button type="submit" disabled={busy} style={buttonStyle}>
          {busy ? "Prüfe…" : "Einloggen"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  padding: "12px 14px", borderRadius: "var(--radius-md)", border: "1px solid var(--line-1)", fontSize: "15px",
};
const buttonStyle = {
  padding: "12px 14px", borderRadius: "var(--radius-md)", border: "none",
  background: "var(--brand)", color: "#fff", fontWeight: 700, fontSize: "15px", cursor: "pointer",
};
